module.exports = ({
    "CDMS911P001": "กรุณากรอกอีเมล",
    "CDMS911P002": "กรุณากรอกรหัสผู้ใช้งานของคุณ",
    "CDMS911P003": "กรุณากรอกหมายเลขโทรศัพท์ของคุณ",
    "CDMS911P004": "กรุณากรอกชื่อองค์กร",
    "CDMS911MSG001": "กรุณากรอกอีเมล",
    "CDMS911MSG002": "อีเมลที่ใส่ได้ถูกลงทะเบียนไว้แล้ว",
    "CDMS911MSG003": "อีเมลที่ใส่ได้ถูกลงทะเบียนไว้แล้วโดยผู้ใช้งานอื่น",
    "CDMS911MSG004": "กรุณากรอกชื่อผู้ใช้งาน",
    "CDMS911MSG005": "บัญชีอีเมลนี้ได้ลงทะเบียนแล้ว แต่ชื่อผู้ใช้งานที่ลงทะเบียนไม่ใช่ [{email}] โปรดลองใหม่อีกครั้ง",
    "CDMS911MSG006": "กรุณาใส่องค์กร",
    "CDMS911MSG007": "กรุณาเลือกหน้าที่",
    "CDMS911MSG008": "กรุณาเลือกสถานวิจัย",
    "CDMS911MSG009": "หน้าที่และสถานวิจัยได้รับการตั้งค่าเรียบร้อยแล้ว",
    "CDMS912MSG001": "คุณแน่ใจหรือไม่ว่าต้องการลบหน้าที่?",
    "CDMS912MSG002": "กรุณาใส่วันที่เริ่มต้น",
    "CDMS911LB001": "อีเมล",
    "CDMS911LB002": "รหัสผู้ใช้งาน",
    "CDMS911LB003": "ชื่อผู้ใช้งาน",
    "CDMS911LB004": "เบอร์โทรศัพท์",
    "CDMS911LB005": "องค์กร",
    "CDMS911LB006": "ปิดการใช้งาน",
    "CDMS911LB007": "ตำแหน่ง",
    "CDMS911LB008": "สถานวิจัย",
    "CDMS911LB009": "ลบ",
    "CDMS911LB010": "ผู้ใช้",
    "CDMS911LB011": "วันที่เริ่มต้น",
    "CDMS911LB012": "วันที่สิ้นสุด",
    "CDMS911LB013": "ภาษา",
    "CDMS911TT001": "การลงทะเบียนผู้ใช้งาน",
    "CDMS911TT002": "ข้อมูลเบื้องต้น",
    "CDMS911TT003": "สถานวิจัย",
    "CDMS911TT004": "การอัปเดตผู้ใช้งาน",
    "CDMS911OPT001": "ทั้งหมด"
});
